var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('Tab',{attrs:{"routerName":_vm.routerName}}),_c('Query')],1),_c('b-col',{attrs:{"cols":"9"}},[_c('Content',{attrs:{"routerName":_vm.routerName}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }